import React from 'react';
import { BasicModal } from '@DesignSystem/modals';
import styles from '../ViewSelect.module.scss';

export type ConfirmRegenerateModalProps = {
  isOpened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
};
const ConfirmRegenerateModal: React.FC<ConfirmRegenerateModalProps> = ({
  isOpened,
  onClose,
  onConfirm,
  isLoading
}) => {
  const handleClose = () => {
    if (isLoading) return;

    onClose();
  };

  return (
    <BasicModal
      open={isOpened}
      onClose={handleClose}
      title="Regenerate this view?"
      className={styles.deleteViewModal}
      content={
        <div className={styles.deleteViewModalContent}>
          Regenerating the view will update the panels and discard any manual
          edits. This action cannot be undone. You can save your manual edits by
          duplicating the view.
        </div>
      }
      primaryButtonText="Yes, regenerate"
      secondaryButtonText="Cancel"
      onSecondaryButtonClick={handleClose}
      onPrimaryButtonClick={onConfirm}
      isPrimaryBtnLoading={isLoading}
    />
  );
};

export default ConfirmRegenerateModal;
